import React from 'react';
import { VisuallyHidden } from '@leagueplatform/genesis-commons';
import { Box, HeadingText, Modal, styled } from '@leagueplatform/genesis-core';

const DEFAULT_HEADER_HEIGHT = '50px';

const modalTitleId = 'iframe-modal-title';

type IframeModalProps = {
  onClose?: () => void;
  children: React.ReactNode;
  title?: string;
  headerHeight?: string;
};

const ContentWrapper = styled(Box, {
  height: 'calc(100vh - 96px)',
  overflow: 'hidden',
  position: 'relative',
  width: '85vw',
  borderRadius: 'medium',
});

const HeaderBlock = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$surface.background.primary',
  borderBottom: '1px solid $border.subtle',
});

const ModalBody = styled(Box, {
  width: '100%',
  backgroundColor: '$surface.background.primary',
});

export const IframeModal = ({
  onClose,
  children,
  headerHeight = DEFAULT_HEADER_HEIGHT,
  title,
}: IframeModalProps) => (
  <Modal.Root
    defaultOpen
    onOpenChange={(open) => {
      if (!open && onClose) {
        onClose();
      }
    }}
  >
    <Modal.Content
      showCloseButton={!!onClose}
      width="auto"
      css={{
        '.GDS-modal': { zIndex: 7000 },
        '.GDS-modal-overlay': { zIndex: 7000 },
        '.GDS-modal-close-button-wrapper': {
          padding: '$half',
        },
      }}
      padding="none"
    >
      <Modal.Title>
        <VisuallyHidden>{modalTitleId}</VisuallyHidden>
      </Modal.Title>
      <ContentWrapper>
        {/* Header Block - only show if title exists */}
        {title && (
          <HeaderBlock css={{ height: headerHeight }}>
            <HeadingText size="lg" level="1">
              {title}
            </HeadingText>
          </HeaderBlock>
        )}
        {/* Modal Body */}
        <ModalBody
          css={{ height: title ? `calc(100% - ${headerHeight})` : '100%' }}
          tabIndex={0}
        >
          {children}
        </ModalBody>
      </ContentWrapper>
    </Modal.Content>
  </Modal.Root>
);
